import { FC } from 'react';
import { Box, Button, ButtonAppearance, ButtonProps, ButtonSize } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const WeldDetailItemTabStyled = styled(Box).attrs({ my: { sm: '100' }, pl: { sm: '100' } })`
  background-color: ${({ theme }) => theme.colors.white};
`;

export interface TabButtonProps extends ButtonProps {
  selected: boolean;
}
export const TabButtonStyled = styled(Button as FC<TabButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.LARGE,
})`
  width: auto;
  border: none;
  border-radius: 0;
  position: relative;
  &:focus {
    border-color: transparent;
    box-shadow: none;
  }
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    font-size: ${theme.fontSizes['400']};
    padding-left: ${theme.spacings[600]};
    padding-right: ${theme.spacings[600]};
    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 5px;
      background-color: ${theme.colors.blue['700']};
      opacity: 0;
    }
  `};
  ${(props) =>
    props.selected &&
    css`
      font-weight: ${props.theme.fontWeights[600]};
      &::after {
        opacity: 1;
      }
    `};
`;
